// import { validateSchema } from 'src/feathers/hooks';
// import yup from 'src/feathers/yup';
import feathers from '@feathersjs/client';
const { FeathersError } = feathers.errors;

// Image uploads must use a REST provider to user multipart-form.
// api/documents service is disallowed() for socket.io. But, our
// clientside `app` is configured as socket.io. Skip the actual
// service call by using standard fetch and setting context.result
const useFetch = async (context) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/job-documents`,
    {
      method: 'POST',
      headers: {
        Authorization: context.params.accessToken
      },
      body: context.data
    }
  );
  if (response.ok) {
    context.result = await response.json();
  } else {
    const error = await response.json();
    throw new FeathersError(error);
  }
  return context;
};

export default (app) => {
  const service = app.service('api/job-documents');
  service.name = 'jobDocuments';

  // service.schema = yup.object({
  //   job_id: yup._id().label('Job ID'),
  // });

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [useFetch],
      update: [],
      patch: [],
      remove: []
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
